import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Classes from '../../../common/Classes';
import Utils from '../../../common/Utils';
import mixpanelConstants from '../../../common/mixpanelConstants';

const Brands = (props) => {
  const {
    id, translations, tag, detailPageLink, triggerMixpanelEvent, representedBrands
  } = props;

  const brandsExist = representedBrands && representedBrands.length > 0;

  if (!brandsExist) return null;

  return (
    <div data-testId="exh-brands" className={classnames(Classes.brands)}>
      <h4 className={Classes.titleInExhibitorSummary}>{translations.brandsLabel}</h4>
      <a
        href={detailPageLink}
        data-dtm={tag}
        data-dtm-attributes={JSON.stringify({ exhibitorId: id })}
      >
        <p className={Classes.wrapWord}
           onClick={() => triggerMixpanelEvent(mixpanelConstants.element.brands)}>
          {Utils.commaSeparateElements(representedBrands.map(brand => (brand.isMatch ? <mark key={brand.value} >{brand.value}</mark> : brand.value)))}
        </p>
      </a>
    </div>
  );
};

Brands.propTypes = {
  detailPageLink: PropTypes.string.isRequired,
  translations: PropTypes.object.isRequired,
  representedBrands: PropTypes.array,
  tag: PropTypes.string,
  id: PropTypes.string.isRequired,
  triggerMixpanelEvent: PropTypes.func,
};

export default Brands;
